import { EnvDef } from "./environment.defs";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: EnvDef = {
	production: false,
	forceLive: true,
	slices: {
		appointments: 51383,
		barbers: 51418,
		hours: 51648,
		inventory: 51443,
		clients: 51373,
		customers: 51363,
		settings: 51728,
		serviceTimes: 51393,
		shifts: 51463,
		shiftStatus: 51658,
	},
	// debug: {
	// 	showAppointment: 8928,
	// }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
